<!--Header responsible for arrows-->
<app-generic-header
  [goBack]="saveChangesButton ? saveButton.bind(this) : exitButton.bind(this)"
  [variant]="
    saveChangesButton ? 'save' : 'back'
">
</app-generic-header>

<ion-content class="ion-padding">

  <div class="centralized">
    
    <div class="page-image">
      <ion-icon src="/assets/imgs/custom-svg/padronized-sizes/lookingFor.svg"></ion-icon>
    </div>

    <div class="page-name">
      {{'whatAreYouLookingFor' | translate}}
    </div>

    <div class="button-list">

      <ion-button value= "seriousRelationship"
      [attr.fill]="hasOption('seriousRelationship') ? 'solid' : 'outline'"
      size="small"
      shape="round" 
      [ngClass]="{ 'unselected': hasOption('seriousRelationship') !== true }"
      (click)="setNewOption('seriousRelationship')">
      {{'seriousRelationship' | translate}}
    </ion-button>

    <ion-button value= "justADate"
    [attr.fill]="hasOption('justADate') ? 'solid' : 'outline'"
    size="small"
    shape="round" 
    [ngClass]="{ 'unselected': hasOption('justADate') !== true }"
    (click)="setNewOption('justADate')">
    {{'justADate' | translate}}
  </ion-button>

  <ion-button value= "friendship"
    [attr.fill]="hasOption('friendship') ? 'solid' : 'outline'"
    size="small"
    shape="round" 
    [ngClass]="{ 'unselected': hasOption('friendship') !== true }"
    (click)="setNewOption('friendship')">
    {{'friendship' | translate}}
  </ion-button>
  
  <ion-button value= "openRelationship"
  [attr.fill]="hasOption('openRelationship') ? 'solid' : 'outline'"
  size="small"
  shape="round" 
  [ngClass]="{ 'unselected': hasOption('openRelationship') !== true }"
  (click)="setNewOption('openRelationship')">
  {{'openRelationship' | translate}}
</ion-button>      

<ion-button value= "openForAnything"
[attr.fill]="hasOption('openForAnything') ? 'solid' : 'outline'"
size="small"
shape="round" 
[ngClass]="{ 'unselected': hasOption('openForAnything') !== true }"
(click)="setNewOption('openForAnything')">
{{'openForAnything' | translate}}
</ion-button>      

<ion-button value= "dontKnowYet"
[attr.fill]="hasOption('dontKnowYet') ? 'solid' : 'outline'"
size="small"
shape="round" 
[ngClass]="{ 'unselected': hasOption('dontKnowYet') !== true }"
(click)="setNewOption('dontKnowYet')">
{{'dontKnowYet' | translate}}
</ion-button>     

</div>

<div class="next-buttons" [hidden] = "userData?.interest2 === null">
  <ion-button fill="outline" mode= "md" class="back-button" (click)="backButton()" size="small" value="back"  shape="round">{{ 'backSurvey' | translate }}</ion-button>

  <ion-button mode= "md" (click)="nextButton()" size="small" value="next" shape="round">{{ 'nextSurvey' | translate }}</ion-button>
</div>

  </div>
</ion-content>